module.exports = __webpack_public_path__ + "h5/img/mfe_04.a84f4541.jpeg";